import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'
import { KeyboardArrowDown as KeyboardArrowDownBase, Search } from '@mui/icons-material'
import { TableCell as TableCellBase } from '@chilecompra/react-kit/components'
import { SORT_DIRECTIONS_DICTIONARY } from './DataTable.utils'

export const Root = styled(({ margin, padding, ...props }) => <div {...props} />)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: 100%;
`

export const GridContainer = styled(({ margin, overflowX, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    overflow-x: ${props => props.overflowX};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Label = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.01071em;
  line-height: 40px;
  margin: 0;
`

export const TableCell = styled(
  ({ enableFilter, enableSort, header, initialDirection, initialSort, verticalAlign, ...props }) => (
    <TableCellBase {...props} />
  )
)`
  &.MuiTableCell-root {
    cursor: ${props => (props.enableSort ? 'pointer' : 'initial')};
    pointer-events: ${props => (props.enableSort || !props.header ? 'initial' : 'none')};
    position: relative;
    user-select: ${props => (props.header ? 'none' : 'initial')};
    vertical-align: ${props => props.verticalAlign};
  }
`
export const SearchIcon = styled(Search)`
  color: ${({ theme }) => theme.palette.blue[50]};
  font-size: 16px;
  margin-right: 8px;
`
export const SortIcon = styled(({ direction, opacity, ...props }) => <KeyboardArrowDownBase {...props} />)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black2};
    font-size: 1.1rem;
    margin: auto 0 auto 8px;
    opacity: ${props => props.opacity || '1'};
    position: absolute;
    transform: rotateX(${props => (props.direction === SORT_DIRECTIONS_DICTIONARY.DESC ? '0' : '180deg')});
  }
`

export const Results = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 12px;
  line-height: 48px;
  margin: 0;
`
